import React, { useEffect } from 'react';
import PropTypes from 'prop-types';

// Note when using FocusTrap - the child wrapped by this component must be only one and must have a ref
const FocusTrap = ({ children }) => {
  useEffect(() => {
    const focusableElements =
      'button, [href], input, select, textarea, [tabindex]:not([tabindex="-1"])';

    const firstFocusableElement =
      children.ref.current.querySelector(focusableElements); // get first element to be focused
    const focusableContent =
      children.ref.current.querySelectorAll(focusableElements);
    const lastFocusableElement = focusableContent[focusableContent.length - 1]; // get last element to be focused

    const trapFocus = (e) => {
      let isTabPressed = e.key === 'Tab' || e.keyCode === 9;

      if (!isTabPressed) {
        return;
      }

      if (e.shiftKey) {
        // if shift key pressed for shift + tab combination
        if (
          document.activeElement === firstFocusableElement ||
          document.activeElement === children.ref.current
        ) {
          lastFocusableElement.focus(); // add focus for the last focusable element
          e.preventDefault();
        }
      } else {
        // if tab key is pressed
        if (document.activeElement === lastFocusableElement) {
          // if focused has reached to last focusable element then focus first focusable element after pressing tab
          firstFocusableElement.focus(); // add focus for the first focusable element
          e.preventDefault();
        }
      }
    };

    document.addEventListener('keydown', trapFocus);

    return () => {
      document.removeEventListener('keydown', trapFocus);
    };
  }, [children]);

  return <>{children}</>;
};

FocusTrap.propTypes = {
  children: PropTypes.element.isRequired,
};

export default FocusTrap;
